import FourPlayersIntroduction from './twoPlayersIntroduction'

export default FourPlayersIntroduction